module.exports = __webpack_public_path__ + "static/media/london-park.a411fc8b.jpg";